import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import FirstTimeBuyerByState from "@/pages/FirstTimeBuyerByState";

export const Route = createFileRoute("/first-time-buyer/$state")({
  head: ({ params }) => seoHead(`/first-time-buyer/${params.state}`),
  component: FirstTimeBuyerByState,
});
